$(function () {
    if ($("#requestHelpModal").length > 0) {

        $("#addRequestHelp").on('click', function () {
            $('.form-check-input').each(function () {
                this.checked = false;
            }); 
            $("#descHelp").val("");

            $("#descHelpError").addClass("d-none");
            /*$("#contactError").addClass("d-none");*/
            $("#contactTimeError").addClass("d-none");

            $("#requestHelpModal").modal('show');
            return false;
        });

        $("#requestHelpBtn").on("click", function () {
            var descHelp = $("#descHelp").val()

            //var useemail = $('#contactEmail').val();

            //var usephone = $('#contactPhone').val();

            var ismorning = $('#contactMorning').val();
            var isafternoon = $('#contactAfternoon').val();


            //if ($('input[name="contact"]:checked').length == 0) {
            //    $("#contactError").removeClass("d-none");
            //    return false;
            //}

            if ($('input[name="contactTime"]:checked').length == 0) {
                $("#contactTimeError").removeClass("d-none");
                return false;
            }

            if (descHelp === undefined || descHelp.trim() == "") {
                $("#descHelpError").removeClass("d-none");
                return false;
            }

            var url = '';

            encoded = encodeURIComponent(descHelp);
            appId = $("#applicationId").val();
            requestId = $("#requestId").val();

            var formData = new FormData();

            formData.append('ApplicationId', appId);
            formData.append('RequestId', requestId);
            formData.append('ProblemDesc', descHelp);
            //formData.append('UseEmail', useemail);
            //formData.append('UsePhone', usephone);
            formData.append('ContactInMorning', ismorning);
            formData.append('ConatctInAfternoon', isafternoon);

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/financialassistance/home/requesthelp/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/financialassistance/home/requesthelp/';
            }

            $.ajax({
                url: url,
                method: 'POST',
                contentType: false,
                processData: false,
                data: formData,
                success: function (res) {
                    $('.form-check-input').each(function () {
                        this.checked = false;
                    }); 
                    $("#descHelp").val("");
                    $("#requestHelpModal").modal("hide");
                    location.reload();
                }
            });
        })

        $("#descHelp").on("change", function () {
            $("#descHelpError").addClass("d-none");

            var message = $(this).val();
            if (message !== undefined || message.length > 1000) {
                $(this).val(message.substring(0, 1000));
            }
        })

        //$("input[id='contactEmail']").on('change', function () {
        //    $(this).val(this.checked ? "TRUE" : "FALSE");

        //    $("#contactError").addClass("d-none");
        //})

        //$("input[id='contactPhone']").on('change', function () {
        //    $(this).val(this.checked ? "TRUE" : "FALSE");

        //    $("#contactError").addClass("d-none");
        //})

        $("input[id='contactMorning']").on('change', function () {
            $(this).val(this.checked ? "TRUE" : "FALSE");

            $("#contactTimeError").addClass("d-none");
        })

        $("input[id='contactAfternoon']").on('change', function () {
            $(this).val(this.checked ? "TRUE" : "FALSE");

            $("#contactTimeError").addClass("d-none");
        })
    }
});